<template>
  <div>
    <titlebar :pages="pages" @clicked="selgal"></titlebar>
    <menubar :pages="pages" :pages2="pages2" @clicked="selgal"></menubar>
    <main>
      <div id="content" class="container">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>

import menubar  from './components/menubar.vue'
import titlebar from './components/titlebar.vue'

export default {
  name: 'App',

  components: { titlebar, menubar },

  methods: {
    selgal(v) {
      this.$var.router.push(v)
    }
  },

  data () {
    return {
      pages: [
        { nom: 'Portraits',   id: '/gallery/portraits'  },
        { nom: 'Islands',     id: '/gallery/islands'    },
        { nom: 'Travel',      id: '/gallery/travel'     },
        { nom: 'Japan',       id: '/gallery/japan'      },
        { nom: 'Steel',       id: '/gallery/steel' },
        { nom: 'Desert city', id: '/gallery/desertcity' },
      ],
      pages2: [
        { nom: 'About',       id: '/about'   },
        { nom: 'Studio',      id: '/studio'  },
        { nom: 'Contact',     id: '/contact' }
      ]
    }
  }
}

</script>

<style>

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  -webkit-text-size-adjust: none;
  -webkit-overflow-scrolling: touch;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
}

body {
  font-family: "Helvetica Neue",Helvetica,Arial,"Lucida Grande",sans-serif;
  font-weight: 400;
  letter-spacing: .05rem;
  font-size: 1rem;
  margin: 0;
  min-width: 320px;
}

html {
  font-size: 14px;
  line-height: 1em;
  font-family: sans-serif;
  -webkit-text-size-adjust: 100%;
  line-height: 1em;
}

.container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 50px;
}

.container.add-padding {
  width: calc(100% - 40px);
}

@media screen and (max-width: 750px)
{
  .container {
    padding: 0px;
  }
}

main {
  overflow: hidden;
}

</style>
